import React from "react";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import logofull from "../../../images/logo-full.png";
import Slider from "react-slick";

const CrowselCard2 = () => {

  const cards = [
    { id: 1, title: "AWS Cloud ", description: "Description 1", progress:70 },
    { id: 2, title: "Data Science and Cloud Computing intern", description: "Description 2", progress:50 },
    { id: 3, title: "Python Essential Web Fullstack", description: "Description 3" , progress:90},
    { id: 4, title: "Web Fullstack", description: "Description 4" , progress:30},
    { id: 5, title: "Cloud Computing", description: "Description 5", progress:10 },
    { id: 6, title: "Artificial Intelligence", description: "Description 6" , progress:70},
    { id: 7, title: "Web Fullstack ", description: "Description 7", progress:20 },
    { id: 8, title: "Machine learning", description: "Description 8", progress:90 },
  ];

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 3,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    
<div>
      <h4 className="mt-1">My Modules:</h4>
      <div className="container">
        <Slider {...settings}>
          {cards.map((card) => (
            <div key={card.id} className="d-flex justify-content-center">
              <div
                className="card p-3 mt-3 d-flex flex-column justify-content-between shadow-sm rounded hover-effect"
                style={{ height: "250px", width: "90%" }}
              >
                <div className="d-flex justify-content-center mb-4 mt-auto">
                  <img src={logofull} alt={card.title} className="card-logo" style={{ height: "50px", width: "60px" }} />
                </div>
                <h5 className="card-title text-start fs-6 mb-2">{card.title}</h5>
                
                <div className="progress-bar-container mb-2 mt-auto">
                  <div className="progress" style={{ height: "10px" }}>
                    <div
                      className="progress-bar"
                      role="progressbar"
                      style={{ width: `${card.progress}%`, backgroundColor: "#f97316" }}
                      aria-valuenow={card.progress}
                      aria-valuemin="0"
                      aria-valuemax="100"
                    ></div>
                  </div>
                </div>
                
                <div className="text-start mb-1">{card.progress}%</div>
                
                <div className="d-flex justify-content-center mt-auto">
                  <button className="btn btn-primary w-75">Continue Learning</button>
                </div>
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </div>
  );
};
export default CrowselCard2;
